import en from "./en.json";

/** English texts of this package, merged into the app catalog and the lib facade. */
export const manufacturerCatalog = { app: { manufacturer: en } };
